import React, {
    useEffect,
    useState,
    useContext
} from 'react';
import { DataContext } from "../../store/DataProvider";
import { useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
import BC from "../../components/BrailleCharacter";
import MessageBox from '../../components/MessageBox';
import _ from 'lodash'

function arrayEquals(a, b) {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
}

const SaerchTabView = props => {
    const { t } = useTranslation();
    const context = useContext(DataContext)
    const [list, setList] = useState([])
    const [message, setMessage] = useState('')
    const [messageTitle, setMessageTitle] = useState('')
    const [showMessage, setShowMessage] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [searchedBrailleCharacter, setSearchedBrailleCharacter] = useState({})
    const [searchResult, setSearchResult] = useState([])
    const [selectedresultIndex, setSelectedresultIndex] = useState(0)
    const [searchMultiple, setSearchMultiple] = useState(false)
    useEffect(() => {
        var List = {};
        switch (props.system) {
            case "full":
                List = context.state.full.getCharactersByCategory('0');
                break;
            case "short":
                List = context.state.short.getKuerzungenByCategory('0');
                break;
            case "euro":
                List = context.state.euro.getCharactersByCategory('0')
                break;
            default:
                break;
        }
        setList(List)
        if (props.mode === 'text') {
            setSearchQuery("")
            setSearchResult([])
            setSelectedresultIndex(0)
        } else {
            setSearchedBrailleCharacter({ dots: [0], title: '' })
        }

    }, [context, props])

    useEffect(() => {
        var char = {}
        if (searchMultiple) {
            char = { dots: [0, 0], title: '' }
        } else {
            char = { dots: [0], title: '' }
        }
        setSearchedBrailleCharacter(char)
    }, [searchMultiple])


    const searchText = (text) => {
        setSearchQuery(text)
        setSelectedresultIndex(0)
        var result = [];
        text = props.system === 'full' ? String(text).toUpperCase() : text
        var list_object = Object.entries(list)
        if (text !== "") {
            result = list_object.filter((e) => e[1].title.startsWith(text))
        }
        setSearchResult(result)
    }

    const renderTextField = () => {
        var result = [];
        result.push(
            <div>
                <input type="text" value={searchQuery} onChange={(e) => searchText(e.target.value)}></input>
            </div>
        )
        return result
    }
    const renderSearchResult = () => {
        var result = [];
        var entries = [];
        for (let [index, result] of searchResult.entries()) {
            var obj = Object.assign({}, result[1])
            var aria_label = obj.accessibilityString !== "" ? obj.accessibilityString : obj.title
            entries.push(
                <ListItem
                    className={index === selectedresultIndex ? 'menu_active' : ''}
                    key={Math.random()}
                    aria-label={aria_label}
                    button role="button"
                    onClick={() => {
                        setSelectedresultIndex(index)
                    }}
                >
                    <ListItemText key={Math.random()} aria-label={aria_label}
                        primary={obj.title}
                    />
                </ListItem>
            )
        }
        if (searchResult.length > 0) {
            result.push(
                <div className='search_result_list'>
                    <List>
                        {entries}
                    </List>
                </div>
            )
        } else if (searchQuery !== "") {
            result.push(
                <span>Keine Einträge gefunden</span>
            )
        }

        return result;
    }
    const renderBrailleResult = () => {
        var result = [];
        var entry = {text: ''}
        if (searchResult.length > 0 && props.mode === 'text') {
            entry = Object.assign({}, searchResult[selectedresultIndex][1])
        }
        result.push(
            <div>
                <div>
                    <h1>{entry['title']}</h1>
                </div>
                <div className='HStack'>
                    {renderCharacter()}
                </div>
                <div className='additional_texts'>
                    {renderAdditionalTexts()}
                </div>
            </div>

        )
        return result;
    }
    const renderTextSearch = () => {
        var result = [];
        if (props.mode === "text") {
            result.push(
                <div>
                    <div className='search_result_container'>
                        {renderTextField()}
                        {renderSearchResult()}
                    </div>
                    <div className='braille_result_container'>
                        {renderBrailleResult()}
                    </div>
                </div>
            )
            return result;
        }
    }
    const renderAdditionalTexts = () => {
        var text = ""
        var currentItem = {}
        if (searchResult.length > 0 && props.mode === 'text') {
            currentItem = Object.assign({}, searchResult[selectedresultIndex][1])
            text = currentItem.category + "\n"
            if (_.has(currentItem, 'exception')) {
                text += currentItem.exception !== '' ? `Besonderheit: ${currentItem.exception} \n` : ''
            }
            if (_.has(currentItem, 'accent')) {
                text += currentItem.accent !== '' ? `Umlautung: ${currentItem.accent}\n` : ''
            }
        }
        return text
    }
    //braille search
    const updateSerachedBrailleCharacter = (e, index) => {
        var copy = { ...searchedBrailleCharacter }
        copy.dots[index] = e
        setSearchedBrailleCharacter(copy)
    }
    const searchBraille = () => {
        var list_object = Object.entries(list)
        var searchResult = [];
        if (searchMultiple && searchedBrailleCharacter.dots[1] === 0) {
            searchResult = list_object.filter((e) => e[1].dots[0] === searchedBrailleCharacter.dots[0])
        } else {
            searchResult = list_object.filter((e) => arrayEquals(e[1].dots, searchedBrailleCharacter.dots))
        }
        setMessageTitle(t('search.result'))
        if (searchResult.length === 0) {
            setMessage(`${t('search.not_found_1')} ${props.system === 'short' ? t('search.not_found_short') : t('search.not_found_char')}`)
            setShowMessage(true)
        } else if (searchResult.length === 1) {
            var entry = searchResult[0][1]
            var message = ''
            message += entry.accessibilityString !== '' ? entry.accessibilityString : entry.title;
            message += ", " + entry.category
            if (_.has(entry, 'exception')) {
                message += entry.exception !== '' ? ", " + entry.exception : '';
            }
            setMessage(message)
            setShowMessage(true)
        } else {
            var multiple_nmessage = t('search.multiple_found') + "\n"
            for (let result of searchResult) {
                var entry = result[1]
                multiple_nmessage += entry.accessibilityString !== '' ? entry.accessibilityString : entry.title;
                multiple_nmessage += ", " + entry.category
                if (_.has(entry, 'exception')) {
                    multiple_nmessage += entry.exception !== '' ? ", " + entry.exception : '';
                }
                multiple_nmessage += "\n\n"
            }
            multiple_nmessage = multiple_nmessage.substring(0, multiple_nmessage.length - 2)
            setMessage(multiple_nmessage)
            setShowMessage(true)
        }
    }
    const renderBrailleSearch = () => {
        var result = [];
        if (props.mode === 'braille') {
            result.push(
                <div>
                    {rendrMultiCheck()}
                    <div className='HStack'>
                        {renderCharacter()}
                    </div>
                    <div>
                        <button className='btn btn-success' onClick={searchBraille} aria-label='Suchen'>Suchen</button>
                    </div>
                </div>
            )
        }
        return result;
    }
    const rendrMultiCheck = () => {
        var result = [];
        if (props.system === 'short') {
            result.push(
                <div>
                    <input type="checkbox" value={searchMultiple} checked={searchMultiple} onChange={(e) => setSearchMultiple(e.target.checked)} />Zweiformige Kürzung
                </div>
            )
        }
        return result
    }

    const renderCharacter = () => {
        let characters = [];
        var currentItem = {}
        if (searchResult.length > 0 && props.mode === 'text') {
            currentItem = Object.assign({}, searchResult[selectedresultIndex][1])
        } else if (props.mode === 'braille') {
            currentItem = searchedBrailleCharacter
        }
        for (let index in currentItem.dots) {
            if (index > 0) {
                if (currentItem.dots[index] > 0 || props.mode === 'braille') {
                    characters.push(
                        <BC
                            key={index}
                            character={
                                currentItem.dots.length > 0
                                    ? currentItem.dots[index]
                                    : 0
                            }
                            isReading={props.mode === 'text'}
                            isPartOfMultipleCharacter={currentItem.dots.length > 1}
                            isEuroBraille={props.system === "euro"}
                            characterIndex={index}
                            onCharacterChange={(e) => updateSerachedBrailleCharacter(e, index)}
                        />
                    );
                }
            } else {
                characters.push(
                    <BC
                        key={index}
                        character={
                            currentItem.dots.length > 0
                                ? currentItem.dots[index]
                                : 0
                        }
                        isReading={props.mode === 'text'}
                        isPartOfMultipleCharacter={currentItem.dots.length > 1}
                        isEuroBraille={props.system === "euro"}
                        characterIndex={index}
                        onCharacterChange={(e) => updateSerachedBrailleCharacter(e, index)}
                    />
                );
            }
        }
        return characters;
    }

    return (
        <div>
            {renderTextSearch()}
            {renderBrailleSearch()}
            <MessageBox
                key={'infoMessage'}

                show={showMessage}
                title={messageTitle}
                message={message}
                okTitle='OK'
                okAction={() => setShowMessage(false)}
                onHide={() => setShowMessage(false)}
            />
        </div>

    )
}
export default SaerchTabView